import CurrencyCode from '@/enums/CurrencyCode';
import { NormalizedLocale } from '@/enums/Locale';
import { Price } from '@/types/Price';

const formatPrice = (price: Price, languageCode: NormalizedLocale = NormalizedLocale.EN) => {
	return createPriceLabel(price.value, price.currencyCode, languageCode);
};

const createPriceLabel = (
	price: number,
	currencyCode: string,
	languageCode: NormalizedLocale = NormalizedLocale.EN,
) => {
	if (!currencyCode) {
		return '';
	}
	if (isNaN(price)) {
		price = 0;
	}

	const fromCents = (price ?? 0) / 100;

	return fromCents.toLocaleString(languageCode, {
		style: 'currency',
		currency: currencyCode,
	});
};

const currencySymbols: Record<CurrencyCode, string> = {
	[CurrencyCode.USD]: '$',
	[CurrencyCode.EUR]: '€',
};

const getCurrencySymbol = (currencyCode: CurrencyCode): string => currencySymbols[currencyCode];

const formatPriceForProductSchema = (price?: number): string => ((price ?? 0) / 100).toFixed(2);

export { createPriceLabel, getCurrencySymbol, formatPriceForProductSchema, formatPrice };
